
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-municipals-26m-2019/pactometre",
      function () {
        return require("private-next-pages/3catinfo/eleccions-municipals-26m-2019/pactometre/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-municipals-26m-2019/pactometre"])
      });
    }
  